<template>
  <ion-page id="signin-page">
    <ion-content>
      <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" 
           :style="styleOneFrame" :key="menuTrigger">
        <ion-item>
          <h5>{{ message }}</h5>
        </ion-item>
        
        <div v-show="showState == SHOW_LOGIN">

          <ion-item>
            <ion-input :label="emailString" label-placement="fixed" 
                      :placeholder="enterEmailString" :value="email"
                      @ionInput="emailInputChange">
            </ion-input>
          </ion-item>

          <ion-item>
            <ion-input :label="passwordString" type="password" label-placement="fixed" 
                      :placeholder="enterPasswordString" :value="password"
                      @ionInput="passwordInputChange">
              <ion-input-password-toggle slot="end"></ion-input-password-toggle>
            </ion-input>
          </ion-item>

          <ion-item>
            <ion-grid>
              <ion-row>
                <ion-col>
                  <ion-button expand="block" size="large" @click="doLogin()" >{{ t("Signin") }}</ion-button>
                </ion-col>
                <ion-col>
                  <ion-button color="danger" expand="block" size="large" @click="doForgot()">
                                {{ t("Forgot Password?") }}
                  </ion-button>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-item>
        </div>

        <div v-show="showState == SHOW_ENTER_RESET_CODE">
          <ion-item>
            <ion-label>
              {{ t("For") }} : {{ email }}
            </ion-label>
          </ion-item>
          <ion-item>
            <ion-input :label="t('Reset Code')" label-placement="fixed" 
                      :placeholder="t('Enter Reset Code')" :value="resetCode"
                      @ionInput="resetCodeInputChange">
            </ion-input>
          </ion-item>
          <ion-item>
            <ion-button :disabled="resetCode.length != 6" color="primary" size="large" @click="verifyPasswordResetCode()">
                                {{ t("Verify Reset Code") }}
            </ion-button>
          </ion-item>
        </div>
        <div v-show="showState == SHOW_ENTER_NEW_PASSWORD">
          <ion-label>
            {{ t("For") }} : {{ email }}
          </ion-label>
          <ion-item>
            <ion-input :label="passwordString" type="password" label-placement="fixed" 
                    :placeholder="enterPasswordString" :value="password"
                    @ionInput="passwordInputChange">
              <ion-input-password-toggle slot="end"></ion-input-password-toggle>
            </ion-input>
          </ion-item>
          <ion-item>
            <ion-input :label="passwordString" type="password" label-placement="fixed" 
                    :placeholder="enterPasswordString" :value="password2"
                    @ionInput="password2InputChange">
              <ion-input-password-toggle slot="end"></ion-input-password-toggle>

            </ion-input>
          </ion-item>

          <ion-item>
            <ion-checkbox label-placement="end" @ionChange="resetCookie = !resetCookie">
              <span class="ion-text-wrap">{{ t("Cancel any open sessions on other devices.") }} <i>({{ t("Not needed if you only forgot your password") }})</i></span>
            </ion-checkbox>
          </ion-item>
          <ion-item>
            <ion-button expand="block" size="large" @click="doReset()" >{{ t("Reset Password") }}</ion-button>
          </ion-item>        
        </div>
      
      <div v-if="whichMenu == 'buttons'">
        <ion-item>
          <ion-button expand="full" size="large" @click="returnToButtonMenu()" >{{ t("Return to Big Button Menu") }}</ion-button>
        </ion-item>
      </div>
    </div>
    </ion-content>
  </ion-page>
</template>

<script setup>

import { IonLabel, IonCheckbox,IonGrid,IonRow,IonCol,IonButton,IonItem,IonInput,IonPage, IonContent, modalController, IonInputPasswordToggle } from '@ionic/vue';

import { ref, watch } from 'vue';
import ModalErrorMessage from '@/components/ModalErrorMessage.vue'
import { t } from '@/composables/translateText.js'

import { useGetData } from '@/composables/getData.js'
import { useConnectionStore } from '@/stores/connectionStore';
import { useWindowSizeStore } from '@/stores/windowSizeStore';
import { doStartupCheck } from '@/composables/startupCheck.js'
import { buildStyleToolbar, buildStyleTopline,availableWidthHeight }  from '@/composables/screenSize'

const emit = defineEmits(['signin-status-change','next-item-click'])

const connectionStore = useConnectionStore()

const whichMenu = localStorage.getItem("whichMenu")
const showBigButtons = ref(whichMenu == "buttons" || connectionStore.getShowBigButtons)

const isDark = ref(connectionStore.getDarkmode != "light")
const menuTrigger = ref(0)

const SHOW_LOGIN = 0
const SHOW_ENTER_RESET_CODE = 1
const SHOW_ENTER_NEW_PASSWORD = 2
const SHOW_GOOD_LOGIN = 3

const showState = ref(SHOW_LOGIN)

const TOOLBAR_DONE = 0

const windowSizeStore = useWindowSizeStore()
const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] })

const emailStorage = connectionStore.getEmailAddress
const email = ref( (emailStorage == null) ? "" : emailStorage)

const password = ref("")
const password2 = ref("")
const resetCookie = ref(false)

const resetCode = ref("")
const message = ref(t("Please enter your email & password below"))
const showEmailPassword = ref(true)

const emailString = ref(t("Email"))
const enterEmailString = ref(t("Enter email"))
const passwordString = ref(t("Password"))
const enterPasswordString = ref(t("Enter password"))


 const styleOneFrame = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

updateWidthHeights()

watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** logoff new window size",windowSizeRef.value)
    menuTrigger.value++
    updateWidthHeights()
  })

  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

function afterStartupCallbackRoutine(stuffChanged,errorProgram,errorEntry) {
  if (errorProgram != null)
      openErrorModal(errorProgram,errorEntry)
  menuTrigger.value++
  updateWidthHeights()
  emit('signin-status-change',true)
}

function updateWidthHeights() {
   const availableSpace = availableWidthHeight()
    const subscribePositionTop = availableSpace.topIndent
    const subscribePositionLeft = availableSpace.leftRightIndent + availableSpace.leftIndent
    const subscribeHeight = availableSpace.height - subscribePositionTop + availableSpace.topIndent
    const subscribeWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    styleOneFrame.value.height = subscribeHeight + "px"
    styleOneFrame.value.width = subscribeWidth + "px"
    styleOneFrame.value.top = subscribePositionTop + "px"
    styleOneFrame.value.left = subscribePositionLeft + "px"
}

function emailInputChange(ev) {
    //console.log("email ",ev)
    const value = ev.target.value;
    ///console.log("email",value)
    email.value = value.trim()
  }

function passwordInputChange(ev) {
  //console.log("password ",ev)
  const value = ev.target.value;
  //console.log("password",value)
  password.value = value.trim()
}

function password2InputChange(ev) {
  //console.log("password2 ",ev)
  const value = ev.target.value;
  //console.log("password2",value)
  password2.value = value.trim()
}

function resetCodeInputChange(ev) {
  const value = ev.target.value;
  resetCode.value = value.trim()
}

function toolbarClick(arrayIndex) {

}

function processJsonResponse (json) {
  //console.log(" in callback",json)
  if (json.hasOwnProperty('error')) {
    openErrorModal(json['programRun'],json['error'])
    return;
  }
  switch (json['stat']) {
    case 'e' :
      message.value = t("Email is not in the system")
      break;
    case 'p' :
      message.value = t("Password is incorrect")
      break;
    case 'g' :
      const cookie = json['cookie']
      connectionStore.setUserCookieDummy(cookie,"0")
      connectionStore.setEmailAddress(email.value)
      message.value = t("Welcome Back!")
      showEmailPassword.value = false
      doStartupCheck(true,afterStartupCallbackRoutine)
      break
  }
}

function doLogin () {
  if (email.value == "") {
    message.value = t("Please enter your email address")
    return
  }
  if (password.value == "") {
    message.value = t("Please enter your password")
    return
  }
  message.value = t("checking") + "...."
  var formData = { e : email.value , p: password.value }
  useGetData("chessvis_login.php", formData, processJsonResponse)
}

function returnToButtonMenu() {
  emit("next-item-click","big_button_menu",t("Big Button Menu"),"buttons")
}

function processForgotJsonResponse (json) {
  console.log(" in forgot callback",json)
  if (json.hasOwnProperty('error')) {
    openErrorModal(json['programRun'],json['error'])
    return;
  }
  switch (json['stat']) {
    case 'e' :
      message.value = t("Email is not in the system")
      break;
    case 'g' :
      message.value = t("Password reset email containing code sent")
      break
  }
  showState.value = SHOW_ENTER_RESET_CODE

}

function doForgot () {
  if (email.value == "") {
    message.value = t("Please enter your email address")
    return
  }

  message.value = t("checking") + "...."

  const subjectForEmail = "Chessvis - " + t("Password Reset Request")
  const toEmail = "Chessvis" + t("User")
  const greetingForEmail = t("Hi")
  const topPartOfEmail = t("To reset your password within the 'Chessvis' website, either click on the link below or copy it into your browser and it will take you to a password reset page.")
  const endPartOfEmail = t("If you have any questions, please email me at")

  message.value = t("checking") + "...."
  var formData = { 
    e : email.value,
    subject : subjectForEmail,
    to_name : toEmail,
    greeting : greetingForEmail,
    top : topPartOfEmail,
    end : endPartOfEmail
  }

  useGetData("chessvis_password_reset_code.php", formData, processForgotJsonResponse)
}

function processPasswordResetJsonResponse(json) {
  //console.log(" in callback",json)
  if (json.hasOwnProperty('error')) {
    openErrorModal(json['programRun'],json['error'])
    return;
  }
  switch (json['stat']) {
    case 'g' :
      message.value = t("Password Reset. Please use the 'Sign in' screen with the new password.")
      showState.value = SHOW_LOGIN
      break
    default :
      message.value = json['stat']
      break;
  }
}

function doReset() {
  if (password.value == "") {
    message.value = t("Please enter your password")
    return
  }
  if (password2.value != password.value) {
    message.value = t("Passwords don't match")
    return
  }
  message.value = t("resetting password") + "...."
  var formData = { 
    e : email.value , 
    v : resetCode.value, 
    p: password.value,
    reset_cookie : (resetCookie.value) ? "y" : "n"
  }
  //console.log("password reset formdata",formData)
  useGetData("chessvis_password_reset_with_code.php", formData, processPasswordResetJsonResponse)
}

function processVerifyPasswordResetCodeJsonResponse(json) {
  //console.log(" in verify password reset callback",json)
  if (json.hasOwnProperty('error')) {
    openErrorModal(json['programRun'],json['error'])
    return;
  }
  switch (json['stat']) {
    case 'expire' :
      message.value = t("Reset request code has expired")
      break;
    case 'bad' :
      message.value = t("Reset request code is wrong")
      break;
    case 'good' :
      message.value = t("Enter New Password")
      showState.value = SHOW_ENTER_NEW_PASSWORD
      break
  }
}

function verifyPasswordResetCode() {
  message.value = t("checking") + "...."
  var formData = { 
    e : email.value,
    code : resetCode.value
  }
  //console.log("formdata",formData)
  useGetData("ai_password_reset_verify_check.php", formData, processVerifyPasswordResetCodeJsonResponse)
}

</script>

<style scoped>

.item{
  margin:10px auto;
}


</style>